/* unplugin-vue-components disabled */import script from "./GameFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./GameFrame.vue?vue&type=script&setup=true&lang=js"

import "./GameFrame.vue?vue&type=style&index=0&id=9f73d066&lang=less"

const __exports__ = script;

export default __exports__